import { useEffect, useRef } from "react";

/**
 * Leva à vista o aviso de erro do servidor: o corpo do modal rola, e o aviso nasce no fim dele,
 * atrás do rodapé. A View só liga `erroRef` ao invólucro do aviso.
 */
export function useRolarAteErro(mensagem: string | null) {
  const erroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!mensagem) return;
    erroRef.current?.scrollIntoView?.({ block: "nearest" });
  }, [mensagem]);

  return erroRef;
}
